@if (false) {
    <div
        class="agpr-targetingSearch-prCopilot"
        [ngClass]="{'expanded': prCopilotExpanded}"
        [agprLoading]="prCopilotLoading"
        [loadingMessage]="'Discover.targeting.search.prCopilot.loadingMessage'"
    >
        <div class="agpr-targetingSearch-prCopilot-heading">
            @if (prCopilotExpanded) {
                <agpr-button
                    [id]="id + '_prCopilot_collapseToggle'"
                    class="agpr-targetingSearch-prCopilot-heading-collapseToggle"
                    [icon]="'fa-regular fa-angle-up'"
                    [style]="buttonTypes.icon"
                    (click)="prCopilotExpanded = false;"
                ></agpr-button>
            } @else {
                <agpr-button
                    [id]="id + '_prCopilot_expandToggle'"
                    class="agpr-targetingSearch-prCopilot-heading-expandToggle"
                    [style]="buttonTypes.link"
                    (click)="prCopilotExpanded = true;"
                >
                    <div class="agpr-targetingSearch-prCopilot-heading-title">
                        <span class="fa-kit-duotone fa-agpr-ai-contacts" aria-hidden="true"></span>
                        <span class="agpr-targetingSearch-prCopilot-heading-title-text">
                            {{ 'Discover.targeting.search.prCopilot.heading' | localize }}
                        </span>
                        <span class="fa-regular fa-circle-info" [agprTooltip]="'Discover.targeting.search.prCopilot.description'"></span>
                    </div>
                    <span
                        class="fa-regular fa-angle-down"
                    ></span>
                </agpr-button>
            }
        </div>

        @if (prCopilotExpanded) {
            <div
                class="agpr-targetingSearch-prCopilot-content"
                @panelContent
            >
                <div class="agpr-targetingSearch-prCopilot-content-heading">
                    <div class="agpr-targetingSearch-prCopilot-heading-title">
                        <span class="fa-agpr-ai-contacts fa-kit-duotone" aria-hidden="true"></span>
                        <span class="agpr-targetingSearch-prCopilot-heading-title-text">
                            {{ 'Discover.targeting.search.prCopilot.description' | localize }}
                        </span>
                    </div>
                </div>
                <div class="agpr-targetingSearch-prCopilot-content-options">
                    <div class="agpr-targetingSearch-prCopilot-content-distribution">
                        <agpr-radio
                            [id]="id + '_prCopilot_distributionQuery'"
                            [name]="'copilotQueryType'"
                            [label]="'Discover.targeting.search.prCopilot.distribution'"
                            [value]="copilotQueryTypes.distribution"
                            [(ngModel)]="prCopilotQueryType"
                        ></agpr-radio>
                        <div
                            class="agpr-targetingSearch-prCopilot-content-input"
                            [ngClass]="{'agpr-targetingSearch-prCopilot-content-input--hidden': prCopilotQueryType !== copilotQueryTypes.distribution}"
                        >
                            <agpr-autocomplete
                                [id]="id + '_prCopilot_distributionQuery_input'"
                                [suggestions]="distributionSuggestions"
                                [(ngModel)]="selectedDistribution"
                                labelField="label"
                                [dropdown]="true"
                                [clearOnBlur]="false"
                                placeholder="Discover.targeting.search.prCopilot.distribution.placeholder"
                                (itemSelected)="distributionSelected($event)"
                                (clear)="distributionSelected(null)"
                            ></agpr-autocomplete>
                        </div>
                    </div>
                    <div class="agpr-targetingSearch-prCopilot-content-text">
                        <agpr-radio
                            [id]="id + '_prCopilot_textQuery'"
                            [name]="'copilotQueryType'"
                            [label]="'Discover.targeting.search.prCopilot.text'"
                            [value]="copilotQueryTypes.text"
                            [tooltip]="'Discover.targeting.search.prCopilot.text.tooltip'"
                            [(ngModel)]="prCopilotQueryType"
                        ></agpr-radio>
                        @if (prCopilotQueryType === copilotQueryTypes.text) {
                            <div class="agpr-targetingSearch-prCopilot-content-input">
                                <agpr-textarea-input
                                    [id]="id + '_prCopilot_textQuery_input'"
                                    [bottomMargin]="false"
                                    [(ngModel)]="prCopilotTextQuery"
                                    [maxLength]="MAX_SEARCH_SIZE"
                                ></agpr-textarea-input>
                            </div>
                        }
                    </div>
                </div>

                <div class="agpr-targetingSearch-prCopilot-content-submit">
                    @let disable = (prCopilotQueryType === copilotQueryTypes.distribution && !selectedDistribution)
                        || (prCopilotQueryType === copilotQueryTypes.text && prCopilotTextQuery.length === 0);
                    <agpr-button
                        [id]="id + '_prCopilot_submit'"
                        [label]="'Discover.targeting.search.prCopilot.submit'"
                        [style]="buttonTypes.tertiary"
                        (click)="getRecommendedRecipientsQuery()"
                        [disabled]="disable"
                        [tooltip]="disable ? 'Discover.targeting.search.prCopilot.submit.tooltip' : ''"
                    ></agpr-button>
                </div>
            </div>
        }
    </div>
}


<ng-container
    [formGroup]="contactForm"
    class="agpr-targetingSearch-center"
>
    <div
        role="group"
        [attr.aria-label]="'Discover.targeting.rhp.contactDetails' | localize"
    >
        <div class="agpr-targetingSearch-mainFields-includeExcludeContainer nameField">
            <div class="agpr-targetingSearch-mainFields-basicChips">
                <agpr-autocomplete-chips
                    formControlName="contacts"
                    [id]="id + '_contactNames_includeExclude'"
                    header="Discover.targeting.searchFieldLabels.contact.names"
                    headerStyleClass="agpr-targetingSearch-fieldLabels"
                    placeholder="Discover.targeting.searchFieldLabels.contactNames.placeholder"
                    field="name"
                    [autocompleteOptions]="contactNameAutocompleteChipsOptions"
                    [itemTemplate]="itemTemplate"
                >
                    <ng-template let-item #itemTemplate>
                        @if (item?.entityType) {
                            <li
                                pRipple
                                class="p-autocomplete-item agpr-targetingSearch-listItemContainer"
                            >
                                <agpr-journodex-entity-list-item
                                    [entity]="item"
                                ></agpr-journodex-entity-list-item>
                            </li>
                        }
                    </ng-template>
            </agpr-autocomplete-chips>
            </div>
        </div>
        <div class="agpr-targetingSearch-mainFields">
            <div class="agpr-targetingSearch-mainFields-leftColumn">
                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-chips
                        formControlName="keywords"
                        [id]="id + '_covering_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.monitoringKeywords"
                        placeholder="Discover.targeting.searchFieldLabels.monitoringKeywords.placeholder"
                        tooltip="Discover.targeting.searchFieldLabels.contact.monitoringKeywords.tooltip"
                        [chipValidations]="keywordValidators"
                        [splitOnPattern]="splitOnPattern"
                    ></agpr-include-exclude-chips>
                </div>

                @if (
                    (previewCount >= MAX_SEARCH_SIZE && !previewLoading) &&
                    (keywords.include.length > 0 || keywords.exclude.length > 0 || keywords.includeAll?.length > 0)
                ) {
                    <div class="agpr-targetingSearch-message">
                        <agpr-message [severity]="messageSeverity.warning">
                            {{ 'Discover.targeting.searchFieldLabels.keywords.broad' | localize }}
                        </agpr-message>
                    </div>
                }

                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-subject-chips
                        formControlName="subjects"
                        [id]="id + '_coveringSubjects_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.coveringSubjects"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        tooltip="Discover.targeting.searchFieldLabels.coveringSubjects.tooltip"
                        (browseAll)="showSubjectsBrowser(subjectKey.subjects, $event)"
                    ></agpr-include-exclude-subject-chips>
                </div>
                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-chips
                        formControlName="geographies"
                        [id]="id + '_regions_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.regions"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        tooltip="Discover.targeting.searchFieldLabels.contactRegions.tooltip"
                        labelLookupField="displayString"
                        [autocompleteOptions]="{
                            suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService),
                            customOptions: [noContentMessages['region']]
                        }"
                        [showIncludeAll]="false"
                        (browseAll)="showRegionBrowser(regionKey.geographies, $event)"
                    ></agpr-include-exclude-chips>

                    @if (geographies.errors?.['duplicateRegions']) {
                        <agpr-form-message [id]="id + '_geographies_error'">
                            {{ 'Discover.targeting.rhp.regionsConflictError' | localize }}
                        </agpr-form-message>
                    }
                </div>
            </div>
            <div class="agpr-targetingSearch-mainFields-rightColumn">
                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-chips
                        formControlName="jobTitles"
                        [id]="id + '_jobTitles_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.jobTitles"
                        placeholder="Discover.targeting.searchFieldLabels.jobTitles.placeholder"
                        [showIncludeAll]="false"
                        [chipValidations]="[minCharacterValidator]"
                    ></agpr-include-exclude-chips>
                </div>
                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-chips
                        formControlName="jobRoles"
                        [id]="id + '_jobRoles_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.jobRoles"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        labelLookupField="displayString"
                        [autocompleteOptions]="{
                            suggestionsFetcher: journodexEnumsService.jobRoleAutocomplete.bind(journodexEnumsService),
                            customOptions: [noContentMessages['jobRole']]
                        }"
                        (browseAll)="showJobRoleBrowser($event)"
                    ></agpr-include-exclude-chips>
                </div>
                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-chips
                        formControlName="languages"
                        [id]="id + '_languages_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.languages"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        labelLookupField="name"
                        [autocompleteOptions]="{
                            suggestionsFetcher: localizationService.autocompleteLanguages.bind(localizationService),
                            customOptions: [noContentMessages['language']]
                        }"
                        (browseAll)="showLanguageBrowser($event)"
                    ></agpr-include-exclude-chips>
                </div>
            </div>
        </div>
    </div>
    <div
        class="agpr-targetingSearch-outletFields"
        formGroupName="employment"
    >
        <agpr-panel
            header="Discover.targeting.panels.outletFields"
            [toggleable]="false"
            [isFormGroup]="true"
        >
            <div class="agpr-targetingSearch-mainFields">
                <div class="agpr-targetingSearch-mainFields-leftColumn">
                    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer nameFieldOutlet">
                        <div class="agpr-targetingSearch-mainFields-basicChips">
                            <agpr-autocomplete-chips
                                formControlName="outlets"
                                [id]="id + '_outletNames_includeExclude'"
                                header="Discover.targeting.searchFieldLabels.outlet.names"
                                headerStyleClass="agpr-targetingSearch-fieldLabels"
                                placeholder="Discover.targeting.searchFieldLabels.outletNames.placeholder"
                                [autocompleteOptions]="outletNameAutocompleteOptions"
                                field="name"
                                [itemTemplate]="itemTemplate"
                            ></agpr-autocomplete-chips>
                        </div>
                    </div>
                    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                        <agpr-include-exclude-chips
                            formControlName="outletKeywords"
                            [id]="id + '_outletMonitoringKeywords_includeExclude'"
                            headerLabel="Discover.targeting.searchFieldLabels.monitoringKeywords"
                            tooltip="Discover.targeting.searchFieldLabels.contact.outletMonitoringKeywords.tooltip"
                            placeholder="Discover.targeting.searchFieldLabels.monitoringKeywords.placeholder"
                            [chipValidations]="keywordValidators"
                            [splitOnPattern]="splitOnPattern"
                        ></agpr-include-exclude-chips>
                    </div>

                    @if (
                        (previewCount >= MAX_SEARCH_SIZE && !previewLoading) &&
                        (outletKeywords.include.length > 0 || outletKeywords.includeAll?.length > 0 || outletKeywords.includeAll?.length > 0)
                    ) {
                        <div class="agpr-targetingSearch-message">
                            <agpr-message [severity]="messageSeverity.warning">
                                {{ 'Discover.targeting.searchFieldLabels.keywords.broad' | localize }}
                            </agpr-message>
                        </div>
                    }

                    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                        <agpr-include-exclude-subject-chips
                            formControlName="outletSubjects"
                            [id]="id + '_outletSubjects_includeExclude'"
                            headerLabel="Discover.targeting.searchFieldLabels.coveringSubjects"
                            tooltip="Discover.targeting.searchFieldLabels.coveringSubjects.tooltip"
                            placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                            (browseAll)="showSubjectsBrowser(subjectKey.outletSubjects, $event)"
                        ></agpr-include-exclude-subject-chips>
                    </div>
                </div>
                <div class="agpr-targetingSearch-mainFields-rightColumn">
                    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                        <agpr-include-exclude-chips
                            formControlName="areasOfCoverage"
                            [id]="id + '_areasOfCoverage_includeExclude'"
                            headerLabel="Discover.targeting.searchFieldLabels.targetAudienceRegion"
                            tooltip="Discover.targeting.searchFieldLabels.contactTargetAudienceRegion.tooltip"
                            placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                            labelLookupField="displayString"
                            [autocompleteOptions]="{
                                suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService),
                                customOptions: [noContentMessages['targetAudienceRegion']]
                            }"
                            (browseAll)="showRegionBrowser(regionKey.areasOfCoverage, $event)"
                        ></agpr-include-exclude-chips>
                    </div>
                    @if (hasMediaMarkets) {
                        <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                            <agpr-include-exclude-media-market-chips
                                formControlName="mediaMarkets"
                                [id]="id + '_mediaMarkets'"
                                (browseAll)="openMediaMarketDialog($event)"
                            ></agpr-include-exclude-media-market-chips>
                        </div>
                    }
                </div>
            </div>
        </agpr-panel>
    </div>
</ng-container>

<ng-template let-item #noContentMessageTemplate>
    <agpr-message
        class="agpr-noContentMessage"
        [severity]="item.severity"
    >
        {{ item.noContentMessageLabel | localize }}
    </agpr-message>
</ng-template>
